<template>
    <b-col col cols="10">
        <b-card class="elevation-1" header-class="bg-white p-5 text-center border-bottom-0">
            <template v-slot:header>
                <h5 class="mb-0">{{t('Select your')}}</h5>
                <h2 class="mb-0">{{t('country')}}</h2>
            </template>

            <b-form @submit.prevent="submit">
                <b-form-group class="pb-5 mb-0">
                    <b-overlay :show="show">
                        <b-input-group>
                            <b-input-group-prepend is-text>
                                <i-flag></i-flag>
                            </b-input-group-prepend>

                            <b-select v-model="country" id="countries" required>
                                <option :value="null" disabled>{{t('Choose your country')}}</option>
                                <option v-for="country in countries" :value="country.id" :country_code="country.country_code">{{country[nameKey]}}</option>
                            </b-select>
                        </b-input-group>
                    </b-overlay>
                </b-form-group>

                <div class="d-flex justify-content-center position-relative pt-5">
                    <b-button type="submit" class="btn-rounded-skewed bg-grad position-absolute p-3">
                        <b-icon-check scale="2"></b-icon-check>
                    </b-button>
                </div>
            </b-form>
        </b-card>
    </b-col>
</template>

<script>
    import IFlag from "../../components/Icons/IFlag";

    export default {
        name: "Country",
        components: {IFlag},
        inject: ['dataRepo', 'localStorageRepo'],
        data: () => ({
            countries: [],
            country: null,
            show: true
        }),
        computed: {
            nameKey() {
                return `name_${this.$translate.lang}`;
            }
        },
        methods: {
            submit() {
                this.localStorageRepo.setCountry(this.country);
                let select = document.getElementById('countries');
                let country_code = select.options[select.selectedIndex].getAttribute('country_code');
                this.localStorageRepo.setCountryCode(country_code);
                if (this.$route.query.to) {
                    this.$router.push(this.$route.query.to);
                } else {
                    this.$router.push({name: 'home'});
                }
            }
        },
        mounted() {
            this.dataRepo.countries().then(({data}) => {
                this.countries = data.sort((country1, country2) => {
                    return country1[this.nameKey] > country2[this.nameKey] ? 1
                        : country1[this.nameKey] < country2[this.nameKey] ? -1
                            : 0;
                })
            }).finally(() => this.show = false)
                .catch(err => this.$handleError(err))
        }
    }
</script>

<style scoped>
    .btn-rounded-skewed {
        top: 2.4rem;
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
    }
</style>
